export const environment = {
  supabaseConfig: {
    url: 'https://qydeztuhhzjlauojxbme.supabase.co',
    key: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InF5ZGV6dHVoaHpqbGF1b2p4Ym1lIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDI0OTYxMDYsImV4cCI6MjAxODA3MjEwNn0.ta9k4nH1PqXz1I3rR5ATYxhFYoemqQ7Up6oXyz-yULg',
  }
};
